document.querySelectorAll('#lush-select').forEach((el) => {
    el.addEventListener('change', () => {
        el.form.submit();
    });
});

document.querySelectorAll('.languages').forEach((el) => {
    el.querySelector('[data-trigger]').addEventListener('click', (e) => {
        e.preventDefault();
        el.querySelector('.dropdown').classList.toggle('is-active');
        el.parentNode
            .querySelector('.language-overlay')
            .classList.toggle('is-active');
    });
    el.querySelectorAll('[data-language]').forEach((lang) => {
        lang.addEventListener('click', (e) => {
            e.preventDefault();
            el.querySelector('.dropdown').classList.remove('is-active');
            el.parentNode
                .querySelector('.language-overlay')
                .classList.remove('is-active');

            document.querySelectorAll('#lush-select').forEach((select) => {
                let code = lang.getAttribute('lang');
                currentIndex = select.querySelector('[lang=' + code + ']');
                select.options.selectedIndex = currentIndex.index;
                select.form.submit();
            });
        });
    });
});

document.querySelectorAll('.language-overlay').forEach((overlay) => {
    overlay.addEventListener('click', (e) => {
        document.querySelector('.dropdown').classList.remove('is-active');
        overlay.classList.remove('is-active');
    });
});
